import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
// components
import NavMenu from "components/NavMenu";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

// actions creators
import { setConfigTab } from "redux/ducks/pricesSection";

// views
import { BLUE_RGB } from "utils/colorsTheme";
import Prices from "views/Prices/Prices";
import PricesGraph from "views/PricesGraph/PricesGraph";

const configTabs = [
  {
    id: "001",
    label: "Precios",
    page: <Prices />,
  },
  { id: "002", label: "Metricas", page: <PricesGraph /> },
];

export default function PricesSection() {
  const dispatch = useDispatch();

  const { tab } = useSelector((state) => state.pricesSection.config);

  const handleChangeTabMemoized = useCallback(
    (_event, newValue) => {
      dispatch(setConfigTab(newValue));
    },
    []
  );
  const handleChangeTabIndexMemoized = useCallback(
    (index) => {
      dispatch(setConfigTab(index));
    },
    []
  );

  return (
    <Card>
      <CardHeader color="info" icon>
        <CardIcon color="info">
          <AttachMoneyIcon />
        </CardIcon>
        <h4 style={{ color: "#3c4858" }}>Precios Planta</h4>
      </CardHeader>
      <CardBody>
        <NavMenu
          value={tab}
          onChange={handleChangeTabMemoized}
          onChangeIndex={handleChangeTabIndexMemoized}
          configTabs={configTabs}
          color={BLUE_RGB}
        />
      </CardBody>
    </Card>
  );
}
